function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "AppX_svg__18_a",
  x1: "31.802%",
  x2: "21.874%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#637EFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#C363E5"
})), React.createElement("linearGradient", {
  id: "AppX_svg__19_b",
  x1: "20.729%",
  x2: "71.041%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F6F3FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D9D0FF"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#AppX_svg__18_a)",
  d: "M7.884 14.897L.726 7.74a2.48 2.48 0 010-3.506L4.233.726a2.48 2.48 0 013.506 0l7.158 7.158L21.91.871a2.975 2.975 0 014.208 0l3.01 3.011a2.975 2.975 0 010 4.208l-7.012 7.013-7.013 7.013-7.013 7.013a2.975 2.975 0 01-4.208 0l-3.01-3.011a2.975 2.975 0 010-4.208l7.012-7.013z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#AppX_svg__19_b)",
  d: "M25.443 18.122l3.835 3.835a2.465 2.465 0 010 3.486l-3.835 3.835a2.465 2.465 0 01-3.486 0l-3.835-3.835a2.465 2.465 0 010-3.486l3.835-3.835a2.465 2.465 0 013.486 0z"
});

var SvgAppX = function SvgAppX(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2, React.createElement("path", {
    fill: "#FFF",
    d: "M14.897 7.884L21.91.871a2.975 2.975 0 014.208 0l3.01 3.011a2.975 2.975 0 010 4.208l-7.012 7.013-7.219-7.219z",
    opacity: 0.351,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _ref3));
};

export default SvgAppX;